"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const Bucket_1 = __importDefault(require("./Bucket"));
class Heights {
    constructor({ buckets }) {
        this.buckets = buckets;
    }
}
Heights.fromJSON = (json) => {
    const { buckets } = Object.assign({}, json);
    try {
        if (!Array.isArray(buckets)) {
            throw new Error('buckets should be array');
        }
        const _buckets = buckets.map(bucket => Bucket_1.default.fromJSON(bucket));
        return new Heights({
            buckets: _buckets,
        });
    }
    catch (_a) {
        throw new Error('.facets.height must be a { buckets: { value: string; count: number }[]}');
    }
};
exports.default = Heights;
